<template>
  <div v-if="provider" class="provider">
    <div class="close" @click="closePage">
      <svg-icon name="close" />
    </div>

    <el-row>
      <el-col :span="4" class="avatar">
        <el-avatar
          :src="provider.profile.avatar | avatar128"
          icon="el-icon-user-solid"
        />
      </el-col>
      <el-col :span="15" class="details">
        <div class="name">
          {{ provider.profile.name }}
        </div>
        <div class="speciality">
          {{ provider.profile.service_type ? provider.profile.service_type.name : '' }}
        </div>
        <span class="rating">
          <span>{{ rating }} </span>
          <svg-icon
            v-for="n in 5"
            :key="n"
            name="star"
            :class="{selected: stars >= n}"
          />
        </span>
      </el-col>
    </el-row>

    <ts-delegate :selected="hunter" @hunter-change="changeHunter" />

    <div class="buttons">
      <el-button type="warning" round @click="assignHunter">
        {{ $t('apply') }}
      </el-button>
    </div>
  </div>
</template>

<script>
  import Delegate from './Delegate.vue'
  import { assignHunter } from '@/api/hunters'

  export default {
    components: {
      'ts-delegate': Delegate
    },

    props: {
      provider: Object
    },

    data() {
      return {
        selectedHunter: null
      }
    },

    computed: {
      hunter() {
        if (this.selectedHunter) {
          return this.selectedHunter
        }

        return this.provider.profile.hunter
          ? this.provider.profile.hunter
          : null
      },

      rating() {
        return Math.round(this.provider.profile.average_rating * 10) / 10
      },

      stars() {
        return Math.round(this.provider.profile.average_rating)
      },

      avatar() {
        return this.provider.profile.avatar
          ? this.provider.profile.avatar.thumb_128
          : ''
      }
    },

    watch: {
      provider() {
        this.selectedHunter = null
      }
    },

    methods: {
      closePage() {
        this.$emit('close')
      },

      changeHunter(hunter) {
        this.selectedHunter = hunter
      },

      async assignHunter() {
        assignHunter({
          // eslint-disable-next-line @typescript-eslint/camelcase
          hunter_id: this.selectedHunter ? this.selectedHunter.id : null,
          // eslint-disable-next-line @typescript-eslint/camelcase
          service_provider_id: this.provider.id
        }).then(() => {
          // update providers list
          const params = {}
          this.$store.dispatch('Providers/getProviders', params)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  .provider {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 40px;
    left: 0;
    z-index: 500;

    .close {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      z-index: 600;

      .svg-icon {
        color: $color-text-darker;
      }
    }

    .avatar {
      min-width: 90px;
      color: white;
      padding-top: 2px;

      .el-avatar {
        width: 72px;
        height: 72px;
      }
    }

    .details {
      .name {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: $color-text-regular;
      }

      .speciality {
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        color: $color-text-placeholder;
      }

      .rating {
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: $color-text-regular;

        .svg-icon {
          fill: $menu-icon-color;
          color: $menu-icon-color;
          vertical-align: middle;
          width: 18px;
          height: 18px;
          margin-left: 3px;

          &.selected {
            fill: $color-warning;
            color: $color-warning;
          }
        }
      }
    }

    .buttons {
      position: absolute;
      bottom: 10px;
      left: 0;
      width: 60%;
    }
  }
</style>
